<script setup>
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';
import fiveMixin from '@/composables/fiveMixin';
import { useDeviceDetect } from '@/composables/useDeviceDetect'

const { isMobile } = useDeviceDetect();
const dataStore = useAnalysisDataStore()
const { ...five } = fiveMixin()

const langMode = 'CHNKOR'
const changeDetail = computed(() => dataStore.yData?.분석상세?.대운흐름?.전환상세 || [])

/** 천간/지지 분리 */
function splitGanji(ganji){
  return{
    sky: ganji?.[0] || '',
    earth: ganji?.[1] || ''
  }
}
</script>

<template>
<div class="ys-timeline-box">
  <div class="ys-timeline-innser">
    <div
      v-for="([ganji,age, , ,year], index) in changeDetail"
      :key="index"
      class="timeline-item"
    >
      <div class="timeline-item__title">{{ age }}세</div>
      <div class="timeline-item__year">{{ year }}</div>
      <div class="timeline-item__five_top">
        <span 
          class="txt-round"
          :class="[
            five.getColorFive(splitGanji(ganji).sky),
            langMode === 'CHNKOR' ? 'chnkor' : '',
            langMode
          ]"
        >
          <em class="chn">{{ five.getHanjaTxt(splitGanji(ganji).sky, 'sky') }}</em>
          <em class="txt-main">{{ splitGanji(ganji).sky }}</em>
        </span>
      </div>
      <div class="timeline-item__five_bottom">
        <span 
          class="txt-round"
          :class="[
            five.getColorFive(splitGanji(ganji).earth),
            langMode === 'CHNKOR' ? 'chnkor' : '',
            langMode
          ]"
        >
          <em class="chn">{{ five.getHanjaTxt(splitGanji(ganji).earth, 'earth') }}</em>
          <em class="txt-main">{{ splitGanji(ganji).earth }}</em>
        </span>
      </div>
    </div>
    
  </div>
  <div
    class="timeline-arrow"
    :class="{mobile: isMobile}">
  </div>
</div>

</template>
<style scoped lang="scss">
.ys-timeline-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .ys-timeline-innser {
    display: inline-flex;
    align-items: center;
    gap: 20px;
    
    .timeline-item {
      display: flex;
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      border-radius: 8px;
      background: var(--gray-100-white, #fff);
      .timeline-item__title {
        color: var(--Gray-800, #333);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      .timeline-item__year {
        color: var(--Gray-800, #333);
        text-align: center;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }
  }
}
.timeline-arrow{
  width: 271px;
  height: 50px;
  position: absolute;
  top: 66%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url('@manseImages/ys_timeline_bg.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: -1;
  // &.mobile{
  //   left: 5%;
  // }
}
</style>